/* istanbul ignore file */
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useBudgetUrl } from 'domain/shared/budget';

interface EditBudgetButtonProps extends EditButtonProps {}

const EditBudgetButton = (props: EditBudgetButtonProps) => {
  const { getUpdateEntityUrl } = useBudgetUrl();

  return <EditButton path={id => getUpdateEntityUrl(id)} {...props} />;
};

export default EditBudgetButton;
